import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SupportComponent } from './common-module/support/support.component';
import { WalkthroughComponent } from './common-module/walkthrough/walkthrough.component';

import { FileUploadComponent } from './file-upload/file-upload.component';

const routes: Routes = [
  // { path: '', redirectTo: '/default', pathMatch: 'full' },
  // { path: '', component: WalkthroughComponent },
  // { path: 'onboard', redirectTo: '/onboard/mf/onboard-info', pathMatch: 'full' },
  // { path: 'mf/support', component: SupportComponent },
  // { path: 'trading/support', component: SupportComponent },
  // { path: 'onboard/mf', loadChildren: './onboard-module/onboard.module#OnboardModule' },
  { path: 'onboard/trading', loadChildren: './onboard-module/onboard.module#OnboardModule' },
  // { path: 'onboard/connect-mf', loadChildren: './onboard-module/onboard.module#OnboardModule' },
  // { path: 'onboard/connect-trading', loadChildren: './onboard-module/onboard.module#OnboardModule' },
  // { path: 'onboard/mf-trading', loadChildren: './onboard-module/onboard.module#OnboardModule' },
  // { path: 'onboard/connect-mf-trading', loadChildren: './onboard-module/onboard.module#OnboardModule' },
  // { path: 'modification/trading', loadChildren: './modification-module/modification.module#ModificationModule' },
  // { path: 'modification/mf', loadChildren: './modification-module/modification.module#ModificationModule' },
  // { path: 'file-upload', component: FileUploadComponent },
  // { path: '**', component: WalkthroughComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]

})
export class AppRoutingModule { }
